(() => {
  const isPlaceholder = (img) => {
    const src = img.currentSrc || img.getAttribute('src') || '';
    return !src || src.startsWith('data:');
  };

  const loadFullscreenImages = () => {
    document.querySelectorAll('.astra-standard .product-gallery').forEach((gallery) => {
      const originals = [...gallery.querySelectorAll('.product-gallery__main img')];
      gallery.querySelectorAll('.product-gallery__fullscreen img').forEach((img, index) => {
        const master = img.dataset.master;
        if (master && master.includes('{width}')) {
          const width = Math.min(Math.ceil(img.getBoundingClientRect().width || window.innerWidth), 3840);
          const url = master.replace('{width}', String(width));
          img.setAttribute('srcset', url);
          if (isPlaceholder(img)) img.setAttribute('src', url);
        } else if (window.theme?.LazyImage?.enter) {
          try { window.theme.LazyImage.enter(img, true); } catch (_) { /* Keep the cloned photo visible even if lazyload fails. */ }
        }
        const srcset = img.getAttribute('data-srcset');
        if (srcset && !img.getAttribute('srcset')) img.setAttribute('srcset', srcset);
        const original = originals[index];
        if (original && isPlaceholder(img) && original.currentSrc && !original.currentSrc.startsWith('data:')) {
          img.src = original.currentSrc;
          if (original.getAttribute('srcset')) img.setAttribute('srcset', original.getAttribute('srcset'));
        }
        img.classList.remove('lazyload', 'lazyload--hold');
        img.classList.add('loaded', 'donothide', 'entered');
        img.removeAttribute('loading');
      });
    });
  };

  const openFromImage = (event) => {
    if (document.body.classList.contains('product-gallery-fullscreen')) return;
    if (event.target.closest('.product-gallery__control, .product-gallery__thumbnail, .product-gallery__fullscreen')) return;
    const item = event.target.closest('.astra-standard .product-gallery__main_item--type-image');
    const button = item?.closest('.product-gallery')?.querySelector('.product-gallery__control [data-js-product-gallery-control-fullscreen]');
    if (!button) return;
    window.setTimeout(() => {
      if (!document.body.classList.contains('product-gallery-fullscreen')) button.click();
    }, 0);
  };

  document.addEventListener('click', openFromImage);

  const body = document.body;
  const sync = () => {
    if (!body.classList.contains('product-gallery-fullscreen')) return;
    loadFullscreenImages();
    window.setTimeout(loadFullscreenImages, 50);
    window.setTimeout(loadFullscreenImages, 250);
  };

  new MutationObserver(sync).observe(body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-gallery__fullscreen_arrow')) window.setTimeout(loadFullscreenImages, 0);
  });
  document.addEventListener('keyup', (event) => {
    if (!body.classList.contains('product-gallery-fullscreen')) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      window.setTimeout(loadFullscreenImages, 0);
    }
  });
})();
